import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export const CaretUpIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon w="20px" h="21px" viewBox="0 0 20 21" {...props}>
      <path
        fill="#5F738C"
        fill-rule="evenodd"
        d="M17.5 13.947a.83.83 0 0 0-.244-.589l-6.667-6.667a.83.83 0 0 0-1.178 0l-6.667 6.667a.832.832 0 1 0 1.179 1.178L10 8.46l6.078 6.077a.832.832 0 0 0 1.422-.589"
        clip-rule="evenodd"
      />
    </Icon>
  );
};
